
import trainRoutes from '@/router/trainRoutes'
import gameRoutes from '@/router/gameRoutes'
import serviceIntroductionRoutes from '@/router/serviceIntroductionRoutes'
import myTestRoutes from '@/router/myTestRoutes'
import systemRoutes from '@/router/systemRoutes'
import usersRoutes from '@/router/usersRouter'
import redirect from '@/redirect.vue';
const routes = [
    {
        path:'/',
        name:'home',
        component: () => import(`@/views/public/welcomeView.vue`)
    },
    {
        path:'/main',
        name:'main',
        component: () => import('@/views/main/main.vue')
    },
    {
        path:'/train',
        name:'train',
        children:trainRoutes
    },
    {
        path:'/game',
        name:'game',
        children:gameRoutes
    },
    {
        path:'/serviceIntroduction',
        name:'serviceIntroduction',
        children:serviceIntroductionRoutes
    },
    {
        path:'/system',
        name:'system',
        children:systemRoutes
    },
    {
        path:'/myTest',
        name:'myTest',
        children:myTestRoutes
    },
    {
        path:'/users',
        name:'users',
        children:usersRoutes
    },
    // {
    //     path: '/redirect/login',
    //     name: 'redirect-users',
    //     component: redirect,
    // }
    {
        path: '/redirect/:case/:token',
        name: 'redirect-users',
        component: redirect,
    }
]
export default routes